import moment from 'moment'

export const customer = {
  id: '',
  name: '',
  customerTypeId: '',
  customerType: '',
  updatedAt : moment().format('YYYY-MM-DD'),
}